import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { conversationApi, groupApi } from '@formosa/shared/api/im';
import { getMemberId } from '@formosa/shared/auth/tokenStorage';
import GroupMemberPicker from '../../components/chat/GroupMemberPicker';
import '../../styles/chat.css';

/** /chat/groups/:conversationId/add — OWNER add members */
export default function AddGroupMembersPage() {
  const { conversationId } = useParams();
  const navigate = useNavigate();
  const myId = getMemberId();
  const [title, setTitle] = useState('');
  const [excludeIds, setExcludeIds] = useState(myId != null ? [myId] : []);
  const [selected, setSelected] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    conversationApi
      .getById(conversationId)
      .then((conv) => {
        if (cancelled) return;
        setTitle(conv?.title || '群組');
        const ids = [...(conv?.participantMemberIds || [])];
        if (myId != null && !ids.some((id) => String(id) === String(myId))) {
          ids.push(myId);
        }
        setExcludeIds(ids);
      })
      .catch((e) => {
        if (!cancelled) setError(e?.message || '無法載入群組');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [conversationId, myId]);

  const submit = async () => {
    if (!selected.length) {
      setError('請至少選擇一位成員');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await groupApi.addMembers(
        conversationId,
        selected.map((s) => s.memberId)
      );
      navigate(`/chat/${conversationId}`);
    } catch (err) {
      setError(err?.message || '加人失敗（需為群主；可能被封鎖／隱私拒絕）');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="chat-social-page">
      <header className="chat-social-page__header">
        <Link to={`/chat/${conversationId}`} className="chat-link-btn">
          ← 聊天室
        </Link>
        <h1>邀請進群</h1>
      </header>
      <p className="group-picker__hint">{loading ? '載入中…' : title}</p>

      <div className="group-create-form">
        {!loading ? (
          <GroupMemberPicker value={selected} onChange={setSelected} excludeIds={excludeIds} />
        ) : null}

        {error ? <p className="chat-social-page__error">{error}</p> : null}

        <button
          type="button"
          className="group-create-form__submit"
          disabled={submitting || loading || !selected.length}
          onClick={submit}
        >
          {submitting ? '邀請中…' : `邀請 ${selected.length} 人`}
        </button>
      </div>
    </div>
  );
}
